module.exports = __webpack_public_path__ + "static/img/lrMyAnalysis1.059adf02.png";